import { MutableRefObject, useEffect } from "react";
import { ICustomScrollStore } from "../_store/CustomScrollStoreModel";
import { IPerfectScrollExtensions } from "../scroll/perfectScrollModel";

export interface IHook<E, R = void> {
    (
        ref: E,
        store: ICustomScrollStore,
        extensions: IPerfectScrollExtensions
    ): R;
}

export type IHookListener<T extends (...x: any) => any> = IHook<
    HTMLElement,
    (a: ReturnType<T>) => void
>;

export const buildEffectWithElementHook = (
    fn: IHook<HTMLElement>
): IHook<MutableRefObject<HTMLElement>> => ({ current }, store, extensions) =>
    useEffect(() => {
        if (current) return fn(current, store, extensions);
    }, [current, extensions]);
